import { Route } from 'react-router'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { LandingMobilePage } from 'pages/landingMobile/ui/landingMobilePage'
import { LandingMobileAccessLayout } from 'pages/landingMobile/layout/LandingMobileAccessLayout'

export const LandingMobileRouter = () => {
  return (
    <RoutesWithNotFound>
      <Route element={<LandingMobileAccessLayout />}>
        <Route path={'/'} element={<LandingMobilePage />} />
      </Route>
    </RoutesWithNotFound>
  )
}
